// extracted by mini-css-extract-plugin
export default {"background":"ParticleCanvas_background__PdXDd"};